import styles from "./NotificationAlert.module.scss";
import alertIcon from "assets/images/alert-icon.svg";
import i18n from "i18n";

const NotificationAlert = ({ alert, expandedSidebar }) => {
  if (!alert?.viewNotification) return <></>;

  return (
    <div
      className={styles["notification-alert"]}
      style={{
        width: `calc(100% - ${expandedSidebar ? "210px" : "97px"})`,
        left: expandedSidebar ? "210px" : "97px"
      }}
    >
      <div>
        <img src={alertIcon} />
        <p>{i18n.t("have")} <strong>1</strong> {i18n.t("new.alert.to.proccess")}</p>
      </div>
      <button onClick={alert?.onClick}>{i18n.t("show.alerts")}</button>
    </div>
  );
};

export default NotificationAlert;
